import { VERIFICATIONS_TOKEN } from '@/constants/endpoints';
import { request } from '@/utils/request';
import { OperatingRequest, PharmacyDuty } from './interface';

export const setPharmacyOperating = async (params: OperatingRequest) => {
  const { token, pharmacyId, type } = params;
  const urlType = type === 'OPEN' ? 'activate' : 'deactivate';
  const {
    data: { result }
  } = await request(token).patch(`/pharmacies/${pharmacyId}/${urlType}`);
  return result;
};

export const setPharmacyDutyTime = async (
  token: string,
  dutyTimes: Array<PharmacyDuty>
) => {
  const {
    data: { success }
  } = await request(token).post(`/pharmacies/pharmacy-duties`, {
    dutyTimes
  });
  return success;
};

// 부릉 송장 정보 생성 및 운송 주문 생성
export const requestVroongShippingLabel = async (
  token: string,
  orderId: number,
  addShipping: boolean
) => {
  const {
    data: { result }
  } = await request(token).post(
    `/pharmacies/orders/${orderId}/vroong-shipping-label?labelType=${
      !addShipping ? 'ORDER' : 'SUPPLEMENT'
    }`
  );
  return result;
};

export const requestDoobalHeroShippingLabel = async (
  token: string,
  orderId: number
) => {
  const {
    data: { result }
  } = await request(token).post(
    `/pharmacies/orders/${orderId}/doobal-shipping-label`
  );
  return result;
};

export const createContactToken = async (token: string, target: string) => {
  return request(token).post(VERIFICATIONS_TOKEN, {
    type: 'phone',
    target
  });
};

export const verifyContactToken = async (
  token: string,
  target: string,
  contactToken: string
) => {
  return request(token).put(VERIFICATIONS_TOKEN, {
    type: 'phone',
    target,
    token: contactToken
  });
};

export default {
  setPharmacyOperating,
  setPharmacyDutyTime,
  requestVroongShippingLabel,
  requestDoobalHeroShippingLabel,
  createContactToken,
  verifyContactToken
};
